import(/* webpackMode: "eager" */ "/builds/91/alb-albatros-travel/alb-frontend/src/app/[[...cmspath]]/error.tsx");
